
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma-related types and utilities in a browser. 
 * Use it to get access to models, enums, and input types.
 * 
 * This file does not contain a `PrismaClient` class, nor several other helpers that are intended as server-side only.
 * See `client.ts` for the standard, server-side entry point.
 *
 * 🟢 You can import this file directly.
 */

import * as Prisma from './internal/prismaNamespaceBrowser.ts'
export { Prisma }
export * as $Enums from './enums.ts'
export * from './enums.ts';
/**
 * Model User
 * User model
 */
export type User = Prisma.UserModel
/**
 * Model UserCalcHistory
 * 
 */
export type UserCalcHistory = Prisma.UserCalcHistoryModel
/**
 * Model UserCalcBookmark
 * 
 */
export type UserCalcBookmark = Prisma.UserCalcBookmarkModel
/**
 * Model CalcParams
 * 
 */
export type CalcParams = Prisma.CalcParamsModel
/**
 * Model CRMDetails
 * 
 */
export type CRMDetails = Prisma.CRMDetailsModel
/**
 * Model PowerBIBookmark
 * 
 */
export type PowerBIBookmark = Prisma.PowerBIBookmarkModel
/**
 * Model UserEvent
 * 
 */
export type UserEvent = Prisma.UserEventModel
/**
 * Model SubscriptionInstanceEventDetails
 * 
 */
export type SubscriptionInstanceEventDetails = Prisma.SubscriptionInstanceEventDetailsModel
/**
 * Model DemoEventDetails
 * 
 */
export type DemoEventDetails = Prisma.DemoEventDetailsModel
/**
 * Model TrialEventDetails
 * 
 */
export type TrialEventDetails = Prisma.TrialEventDetailsModel
/**
 * Model SignUpEventDetails
 * 
 */
export type SignUpEventDetails = Prisma.SignUpEventDetailsModel
/**
 * Model UserDetailsEventDetails
 * 
 */
export type UserDetailsEventDetails = Prisma.UserDetailsEventDetailsModel
/**
 * Model InvitationEventDetails
 * 
 */
export type InvitationEventDetails = Prisma.InvitationEventDetailsModel
/**
 * Model OpportunityStatusEventDetails
 * 
 */
export type OpportunityStatusEventDetails = Prisma.OpportunityStatusEventDetailsModel
/**
 * Model Company
 * 
 */
export type Company = Prisma.CompanyModel
/**
 * Model Address
 * 
 */
export type Address = Prisma.AddressModel
/**
 * Model Team
 * 
 */
export type Team = Prisma.TeamModel
/**
 * Model ApiInstance
 * A group of api permissions with attacbed api keys
 */
export type ApiInstance = Prisma.ApiInstanceModel
/**
 * Model FreightMatrixDefinitionOverride
 * When this table is empty for a team, the default freight matrix API definition is used.
 */
export type FreightMatrixDefinitionOverride = Prisma.FreightMatrixDefinitionOverrideModel
/**
 * Model ApiKeys
 * 
 */
export type ApiKeys = Prisma.ApiKeysModel
/**
 * Model ApiPermissions
 * 
 */
export type ApiPermissions = Prisma.ApiPermissionsModel
/**
 * Model ApiRequestLog
 * 
 */
export type ApiRequestLog = Prisma.ApiRequestLogModel
/**
 * Model ApiRateLimits
 * 
 */
export type ApiRateLimits = Prisma.ApiRateLimitsModel
/**
 * Model TeamCRMDetails
 * 
 */
export type TeamCRMDetails = Prisma.TeamCRMDetailsModel
/**
 * Model CommentInstance
 * 
 */
export type CommentInstance = Prisma.CommentInstanceModel
/**
 * Model InvoiceInformation
 * 
 */
export type InvoiceInformation = Prisma.InvoiceInformationModel
/**
 * Model TransactionInstance
 * 
 */
export type TransactionInstance = Prisma.TransactionInstanceModel
/**
 * Model SubscriptionPriceInstance
 * 
 */
export type SubscriptionPriceInstance = Prisma.SubscriptionPriceInstanceModel
/**
 * Model PlatformSubscriptionPriceInstance
 * 
 */
export type PlatformSubscriptionPriceInstance = Prisma.PlatformSubscriptionPriceInstanceModel
/**
 * Model DefaultSubscriptionPrice
 * Default Subscription Price
 */
export type DefaultSubscriptionPrice = Prisma.DefaultSubscriptionPriceModel
/**
 * Model SubscriptionTemplate
 * 
 */
export type SubscriptionTemplate = Prisma.SubscriptionTemplateModel
/**
 * Model SubscriptionFeatureLimit
 * Configurable calculation limits per subscription package
 */
export type SubscriptionFeatureLimit = Prisma.SubscriptionFeatureLimitModel
/**
 * Model SubscriptionInstance
 * 
 */
export type SubscriptionInstance = Prisma.SubscriptionInstanceModel
/**
 * Model SubscriptionRequestInstance
 * 
 */
export type SubscriptionRequestInstance = Prisma.SubscriptionRequestInstanceModel
/**
 * Model SlackMessage
 * 
 */
export type SlackMessage = Prisma.SlackMessageModel
/**
 * Model Invitation
 * 
 */
export type Invitation = Prisma.InvitationModel
/**
 * Model PermissionTemplate
 * 
 */
export type PermissionTemplate = Prisma.PermissionTemplateModel
/**
 * Model PermissionInstance
 * 
 */
export type PermissionInstance = Prisma.PermissionInstanceModel
/**
 * Model PermissionInternalTemplate
 * 
 */
export type PermissionInternalTemplate = Prisma.PermissionInternalTemplateModel
/**
 * Model PermissionInternalInstance
 * 
 */
export type PermissionInternalInstance = Prisma.PermissionInternalInstanceModel
/**
 * Model VerificationToken
 * 
 */
export type VerificationToken = Prisma.VerificationTokenModel
/**
 * Model PasswordResetToken
 * 
 */
export type PasswordResetToken = Prisma.PasswordResetTokenModel
/**
 * Model LoginOtpToken
 * 
 */
export type LoginOtpToken = Prisma.LoginOtpTokenModel
/**
 * Model LoginAttempt
 * 
 */
export type LoginAttempt = Prisma.LoginAttemptModel
/**
 * Model Country
 * 
 */
export type Country = Prisma.CountryModel
/**
 * Model Port
 * 
 */
export type Port = Prisma.PortModel
/**
 * Model LocationCollection
 * 
 */
export type LocationCollection = Prisma.LocationCollectionModel
/**
 * Model LocationCollectionList
 * 
 */
export type LocationCollectionList = Prisma.LocationCollectionListModel
/**
 * Model IncoParity
 * 
 */
export type IncoParity = Prisma.IncoParityModel
/**
 * Model Product
 * 
 */
export type Product = Prisma.ProductModel
/**
 * Model MarketReportTemplate
 * 
 */
export type MarketReportTemplate = Prisma.MarketReportTemplateModel
/**
 * Model MarketReportTemplateGenerationTemplateHistory
 * 
 */
export type MarketReportTemplateGenerationTemplateHistory = Prisma.MarketReportTemplateGenerationTemplateHistoryModel
/**
 * Model MarketReportInstance
 * 
 */
export type MarketReportInstance = Prisma.MarketReportInstanceModel
/**
 * Model MarketReportPublicShare
 * Public tokenized share for a market report instance.
 * One fixed token is generated per report instance so links stay stable.
 */
export type MarketReportPublicShare = Prisma.MarketReportPublicShareModel
/**
 * Model MarketReportGroup
 * 
 */
export type MarketReportGroup = Prisma.MarketReportGroupModel
/**
 * Model MarketReportGroupPriority
 * 
 */
export type MarketReportGroupPriority = Prisma.MarketReportGroupPriorityModel
/**
 * Model SelfCheckoutPlatformSubscriptionPrice
 * Price configuration for platform subscription - self-checkout standalone price
 * 
 * Price Semantics:
 * - This model handles self-checkout prices for platform subscriptions
 * - If a price exists, it can be used for self-checkout
 * - One standalone price per subscription template
 */
export type SelfCheckoutPlatformSubscriptionPrice = Prisma.SelfCheckoutPlatformSubscriptionPriceModel
/**
 * Model MarketReportGroupPrice
 * Price configuration for market report groups - standalone purchasable prices only
 * 
 * Price Semantics:
 * - This model now ONLY handles standalone purchasable prices (no subscription template logic)
 * - Inclusion in platform subscriptions is determined by MarketReportGroupPriority → SubscriptionTemplate links
 * - One standalone price per group per billing interval
 */
export type MarketReportGroupPrice = Prisma.MarketReportGroupPriceModel
/**
 * Model MarketReportEmailPreference
 * User-level email preference for market report groups
 * 
 * This model tracks whether a user wants to receive email reports for a specific market report group.
 * The user must have an active paid subscription (via SelfCheckoutSubscription) that grants access
 * to the group (either directly or through a platform subscription) to receive emails.
 * 
 * Default Behavior (opt-in model):
 * - If no preference record exists for a user+group combination, emails are DISABLED by default
 * - A record with emailEnabled=true is automatically created when a user purchases a subscription
 * (either an individual group subscription or a platform subscription that includes the group)
 * - Users can then explicitly opt out by setting emailEnabled=false
 * 
 * Access Check Logic:
 * 1. User must have active SelfCheckoutSubscription
 * 2. Subscription must include access to this market report group (via group price or a platform subscription)
 * 3. This preference must exist with emailEnabled=true
 */
export type MarketReportEmailPreference = Prisma.MarketReportEmailPreferenceModel
/**
 * Model NewsContentCategory
 * 
 */
export type NewsContentCategory = Prisma.NewsContentCategoryModel
/**
 * Model MarketCommentary
 * 
 */
export type MarketCommentary = Prisma.MarketCommentaryModel
/**
 * Model News
 * 
 */
export type News = Prisma.NewsModel
/**
 * Model MarketEvent
 * 
 */
export type MarketEvent = Prisma.MarketEventModel
/**
 * Model ExchangeMarket
 * 
 */
export type ExchangeMarket = Prisma.ExchangeMarketModel
/**
 * Model FutureContractInstance
 * 
 */
export type FutureContractInstance = Prisma.FutureContractInstanceModel
/**
 * Model FutureInstance
 * 
 */
export type FutureInstance = Prisma.FutureInstanceModel
/**
 * Model Currency
 * 
 */
export type Currency = Prisma.CurrencyModel
/**
 * Model ExchangeRateInstance
 * 
 */
export type ExchangeRateInstance = Prisma.ExchangeRateInstanceModel
/**
 * Model ProductVariant
 * 
 */
export type ProductVariant = Prisma.ProductVariantModel
/**
 * Model ProductHierachy
 * 
 */
export type ProductHierachy = Prisma.ProductHierachyModel
/**
 * Model ProductHierachyInstance
 * 
 */
export type ProductHierachyInstance = Prisma.ProductHierachyInstanceModel
/**
 * Model DocumentRequirement
 * 
 */
export type DocumentRequirement = Prisma.DocumentRequirementModel
/**
 * Model QualityRequirement
 * 
 */
export type QualityRequirement = Prisma.QualityRequirementModel
/**
 * Model BidOfferInstance
 * 
 */
export type BidOfferInstance = Prisma.BidOfferInstanceModel
/**
 * Model BidOfferPremiumUpdate
 * 
 */
export type BidOfferPremiumUpdate = Prisma.BidOfferPremiumUpdateModel
/**
 * Model BidOfferFlatUpdate
 * 
 */
export type BidOfferFlatUpdate = Prisma.BidOfferFlatUpdateModel
/**
 * Model PremiumPriceInstance
 * 
 */
export type PremiumPriceInstance = Prisma.PremiumPriceInstanceModel
/**
 * Model FlatPriceInstance
 * 
 */
export type FlatPriceInstance = Prisma.FlatPriceInstanceModel
/**
 * Model MeasurementUnit
 * 
 */
export type MeasurementUnit = Prisma.MeasurementUnitModel
/**
 * Model BasePortAreas
 * 
 */
export type BasePortAreas = Prisma.BasePortAreasModel
/**
 * Model BasePortDiff
 * 
 */
export type BasePortDiff = Prisma.BasePortDiffModel
/**
 * Model D365CrmCustomer
 * 
 */
export type D365CrmCustomer = Prisma.D365CrmCustomerModel
/**
 * Model NominalPriceUploadInstance
 * 
 */
export type NominalPriceUploadInstance = Prisma.NominalPriceUploadInstanceModel
/**
 * Model NominalPriceInstance
 * 
 */
export type NominalPriceInstance = Prisma.NominalPriceInstanceModel
/**
 * Model NominalPricePremiumInstance
 * 
 */
export type NominalPricePremiumInstance = Prisma.NominalPricePremiumInstanceModel
/**
 * Model NominalPriceFlatInstance
 * 
 */
export type NominalPriceFlatInstance = Prisma.NominalPriceFlatInstanceModel
/**
 * Model FreightQuoteRequests
 * 
 */
export type FreightQuoteRequests = Prisma.FreightQuoteRequestsModel
/**
 * Model FreightQuoteRequestParamSet
 * 
 */
export type FreightQuoteRequestParamSet = Prisma.FreightQuoteRequestParamSetModel
/**
 * Model FreightQuoteRequestPort
 * 
 */
export type FreightQuoteRequestPort = Prisma.FreightQuoteRequestPortModel
/**
 * Model FreightQuoteRequestOperation
 * 
 */
export type FreightQuoteRequestOperation = Prisma.FreightQuoteRequestOperationModel
/**
 * Model FreightMatrixRoute
 * 
 */
export type FreightMatrixRoute = Prisma.FreightMatrixRouteModel
/**
 * Model FreightCalculationMatrixGroup
 * 
 */
export type FreightCalculationMatrixGroup = Prisma.FreightCalculationMatrixGroupModel
/**
 * Model FreightCalculationMatrixGroupInclude
 * 
 */
export type FreightCalculationMatrixGroupInclude = Prisma.FreightCalculationMatrixGroupIncludeModel
/**
 * Model FreightCalculationMatrixGroupItem
 * 
 */
export type FreightCalculationMatrixGroupItem = Prisma.FreightCalculationMatrixGroupItemModel
/**
 * Model FreightMatrixJob
 * 
 */
export type FreightMatrixJob = Prisma.FreightMatrixJobModel
/**
 * Model FreightMatrixPartialJob
 * A partial matrix calculation a team started from the customer freight matrix editor.
 * 
 * Separate from FreightMatrixJob, which names the matrix groups it calculates. A partial job names
 * none, so the pair worth recording is who asked and which engine job answered - which is also what
 * enforces one running calculation per team.
 */
export type FreightMatrixPartialJob = Prisma.FreightMatrixPartialJobModel
/**
 * Model SelectPinnedItem
 * 
 */
export type SelectPinnedItem = Prisma.SelectPinnedItemModel
/**
 * Model WhatsappConnection
 * 
 */
export type WhatsappConnection = Prisma.WhatsappConnectionModel
/**
 * Model Notification
 * 
 */
export type Notification = Prisma.NotificationModel
/**
 * Model NotificationInstance
 * 
 */
export type NotificationInstance = Prisma.NotificationInstanceModel
/**
 * Model NotificationChannel
 * 
 */
export type NotificationChannel = Prisma.NotificationChannelModel
/**
 * Model EntityACL
 * if multiple entries is found for a key, union all values
 * if both userid and teamid is null, use the selection as a default for every user (with his own list)
 */
export type EntityACL = Prisma.EntityACLModel
/**
 * Model LineupAgent
 * 
 */
export type LineupAgent = Prisma.LineupAgentModel
/**
 * Model CropYearDefinition
 * 
 */
export type CropYearDefinition = Prisma.CropYearDefinitionModel
/**
 * Model CropYear
 * 
 */
export type CropYear = Prisma.CropYearModel
/**
 * Model LineupInstance
 * 
 */
export type LineupInstance = Prisma.LineupInstanceModel
/**
 * Model LineupString
 * 
 */
export type LineupString = Prisma.LineupStringModel
/**
 * Model LineupHistory
 * 
 */
export type LineupHistory = Prisma.LineupHistoryModel
/**
 * Model DataJobs
 * 
 */
export type DataJobs = Prisma.DataJobsModel
/**
 * Model FeatureFlags
 * 
 */
export type FeatureFlags = Prisma.FeatureFlagsModel
/**
 * Model FeatureFlagTeamTarget
 * 
 */
export type FeatureFlagTeamTarget = Prisma.FeatureFlagTeamTargetModel
/**
 * Model FeatureFlagUserTarget
 * 
 */
export type FeatureFlagUserTarget = Prisma.FeatureFlagUserTargetModel
/**
 * Model PaymentCustomer
 * 
 */
export type PaymentCustomer = Prisma.PaymentCustomerModel
/**
 * Model SelfCheckoutSubscription
 * Market report subscription model
 * 
 * Subscription Lifecycle:
 * 1. PENDING - Initial state, awaiting first payment
 * 2. ACTIVE - Subscription is active and billing
 * 3. PAST_DUE - Payment failed, grace period active
 * 4. CANCELED - User canceled, may continue until period end
 * 5. EXPIRED - Subscription ended and no longer active
 * 6. PAUSED - Temporarily paused by user or admin
 * 
 * Cancellation Behavior:
 * - cancelAtPeriodEnd=true: Subscription continues until currentPeriodEnd, then status becomes CANCELED
 * - canceledAt: Timestamp when cancellation was requested (may be before subscription actually ends)
 * - When canceled immediately: cancelAtPeriodEnd=false, canceledAt=now, status=CANCELED
 */
export type SelfCheckoutSubscription = Prisma.SelfCheckoutSubscriptionModel
/**
 * Model SelfCheckoutSubscriptionItem
 * Subscription item representing a single product in a subscription
 * 
 * Price Relationship:
 * - Must have EXACTLY ONE price type set (either marketReportGroupPriceId or platformSubscriptionPriceId)
 * - This constraint is enforced at the database level via CHECK constraint "exactly_one_price_type"
 * - Never both, never neither
 * 
 * Archived Price Handling:
 * - Relations to MarketReportGroupPrice may reference archived prices
 * - This preserves historical subscription data even after prices are archived
 * - Business logic should: (a) prevent creating NEW items with archived prices
 * - (b) allow existing items to maintain references to archived prices for billing continuity
 */
export type SelfCheckoutSubscriptionItem = Prisma.SelfCheckoutSubscriptionItemModel
/**
 * Model SubscriptionChange
 * 
 */
export type SubscriptionChange = Prisma.SubscriptionChangeModel
/**
 * Model PaymentProviderProductMapping
 * 
 */
export type PaymentProviderProductMapping = Prisma.PaymentProviderProductMappingModel
/**
 * Model PaymentProviderSubscriptionData
 * 
 */
export type PaymentProviderSubscriptionData = Prisma.PaymentProviderSubscriptionDataModel
/**
 * Model PaymentProviderWebhookEvent
 * Payment provider webhook event tracking
 * 
 * Webhook Retry Behavior:
 * - retryCount: Number of times this event has been retried (starts at 0)
 * - maxRetries: Maximum number of retry attempts allowed (default 3)
 * - nextRetryAt: When to attempt next retry (null if no retry scheduled)
 * - status: PENDING -> PROCESSING -> PROCESSED/FAILED/IGNORED
 * - Exponential backoff recommended: delay = 2^retryCount minutes
 * - After maxRetries exceeded, status becomes FAILED (manual intervention needed)
 */
export type PaymentProviderWebhookEvent = Prisma.PaymentProviderWebhookEventModel
/**
 * Model AuditLog
 * Security and compliance audit log for financial transactions
 * Tracks all important actions for security and compliance requirements
 */
export type AuditLog = Prisma.AuditLogModel
/**
 * Model FormSubmissions
 * Holds forms submitted from PayloadCMS
 */
export type FormSubmissions = Prisma.FormSubmissionsModel
/**
 * Model SupplyDemand
 * 
 */
export type SupplyDemand = Prisma.SupplyDemandModel
/**
 * Model SupplyDemandAttribute
 * 
 */
export type SupplyDemandAttribute = Prisma.SupplyDemandAttributeModel
/**
 * Model SupplyDemandUpload
 * 
 */
export type SupplyDemandUpload = Prisma.SupplyDemandUploadModel
